import React, { useContext } from 'react';
import { useLocation } from 'react-router';

export function isPublicViewPath(path: string) {
  return path.startsWith('/public');
}

const IsPublicViewContext = React.createContext(false);

interface PublicViewProviderProps {
  children: React.ReactNode;
  publicView?: boolean;
}

export const IsPublicViewProvider = ({
  children,
  publicView,
}: PublicViewProviderProps) => {
  const location = useLocation();

  const isPublicView =
    publicView === undefined ? isPublicViewPath(location.pathname) : publicView;

  return (
    <IsPublicViewContext.Provider value={isPublicView}>
      {children}
    </IsPublicViewContext.Provider>
  );
};

const useIsPublicView = () => {
  return useContext(IsPublicViewContext);
};

export default useIsPublicView;
